// Normalises the `details` of a validate/lock refusal into displayable { code, message } items.
// Servers return three shapes: ValidationFailure objects, ACTIVITIES_NOT_MAPPED
// ({ projectId, projectName }) and SHARES_NOT_ADOPTED (bare project id strings).
export interface DisplayFailure { code: string; message: string }

export function normaliseFailureDetails(details: unknown): DisplayFailure[] {
  if (!Array.isArray(details)) return [];
  const out: DisplayFailure[] = [];
  for (const d of details as unknown[]) {
    if (typeof d === 'string') {
      out.push({ code: 'SHARES_NOT_ADOPTED', message: `Adopt an R&D share for project ${d}` });
    } else if (d && typeof d === 'object') {
      const o = d as { code?: unknown; message?: unknown; projectName?: unknown };
      if (typeof o.message === 'string') out.push({ code: typeof o.code === 'string' ? o.code : 'VALIDATION', message: o.message });
      else if (typeof o.projectName === 'string') out.push({ code: 'ACTIVITIES_NOT_MAPPED', message: `Map ${o.projectName} to a claim activity` });
    }
  }
  return out;
}
